import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from '@hydra/common/components';
import { Criterium, CriteriumSkeleton, CriteriumTable } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

export const MixedContent = ({ criterium }) => {
  const { data } = criterium;
  const { variant } = useReviewContext();
  const { isHttps, hasHttpResources, httpResources } = data;

  const rows = httpResources.map(({ url }) => [url]);

  const content = !isHttps || !hasHttpResources
    ? (variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='mixed_content_not_found' />)
    : (
      <>
        <Translate content='mixed_content_found' with={{ count: httpResources.length }} />
        <CriteriumTable rows={rows} striped nowrap />
      </>
      );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

MixedContent.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      isHttps: PropTypes.bool,
      hasHttpResources: PropTypes.bool,
      httpResources: PropTypes.arrayOf(
        PropTypes.shape({
          url: PropTypes.string
        })
      )
    })
  })
};

export default React.memo(MixedContent);
